var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerchantAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 76,
    viewBox: "0 0 94 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7151 0H90.449C92.4061 0 94 1.59973 94 3.56391V52.6717C94 54.6359 92.4061 56.2356 90.449 56.2356H57.4168V65.9791H70.2775C72.4048 65.9791 74.137 67.7208 74.137 69.8527V74.7293C74.137 75.4291 73.5714 75.9968 72.874 75.9968H21.126C20.4286 75.9968 19.863 75.4291 19.863 74.7293V69.8527C19.863 67.7175 21.5984 65.9791 23.7225 65.9791H36.5832V56.2356H3.55099C1.59393 56.2356 0 54.6359 0 52.6717V3.56391C0 1.59973 1.59393 0 3.55099 0H69.7151ZM56.1538 68.5174H23.7258C22.9963 68.5174 22.3921 69.1205 22.3921 69.8559V73.465H71.6111V69.8559C71.6111 69.1238 71.0102 68.5174 70.2775 68.5174H56.1538ZM54.8877 56.2356H39.1123V65.9791H54.8877V56.2356ZM23.3883 8.22119H8.19138V48.0177H85.8086V8.22119H23.3883ZM69.7183 5.68291H87.0748C87.7721 5.68291 88.3377 6.25055 88.3377 6.95043V49.2852C88.3377 49.9851 87.7721 50.5527 87.0748 50.5527H6.92523C6.22789 50.5527 5.6623 49.9851 5.6623 49.2852V6.95043C5.6623 6.25055 6.22789 5.68291 6.92523 5.68291H23.3851V2.53828H3.55099C2.99183 2.53828 2.52908 3.00272 2.52908 3.56391V52.6717C2.52908 53.2329 2.99183 53.6973 3.55099 53.6973H90.449C91.0082 53.6973 91.4709 53.2329 91.4709 52.6717V3.56391C91.4709 3.00272 91.0082 2.53828 90.449 2.53828H69.7151V5.68291H69.7183Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantAppIcon);
export default __webpack_public_path__ + "static/media/MerchantApp_icon.8003decdbc3875f137926f0ed37719a6.svg";
export { ForwardRef as ReactComponent };